const language = {
    'pt': {
        add: 'Adicionar',
        add_new: 'Adicionar Formulário',
        add_field: 'Adicionar Campo',
        all: 'Todos',
        back: 'Voltar',
        calendar: 'Calendário',
        calendar_allday: 'Todo o dia',
        calendar_busy: 'Ocupado',
        calendar_day: 'Dia',
        calendar_daynames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        calendar_delete: 'Apagar',
        calendar_edit: 'Editar',
        calendar_end_placeholder: 'Data de fim',
        calendar_free: 'Livre',
        calendar_language: 'pt-PT',
        calendar_location_placeholder: 'Localização',
        calendar_month: 'Mês',
        calendar_save: 'Salvar',
        calendar_start_placeholder: 'Data de inicio',
        calendar_title_placeholder: 'Assunto',
        calendar_today: 'Hoje',
        calendar_update: 'Atualizar',
        calendar_viewall: 'Ver tudo',
        calendar_week: 'Semana',
        calendar_year: 'Ano',
        cancel: 'Cancelar',
        category: 'Categoria',
        category_edit: 'Editar categoria',
        category_list: 'Lista de categorias',
        category_new: 'Nova categoria',
        close: 'Fechar',
        color: 'Cor',
        color_placeholder: 'Introduza a cor',
        color_primary: 'Cor Primária',
        color_secondary: 'Cor Secundária',
        component: 'Formulário',
        component_edit: 'Editar Formulário',
        component_list: 'Lista de Formulários',
        component_new: 'Novo Formulário',
        conferencia: 'Conferência',
        critica: 'Crítica',
        date: 'Data de início',
        departamento: 'Departamento',
        departamento_placeholder: 'Seleccione o departamento',
        grupo: 'Grupo',
        grupo_placeholder: 'Seleccione o grupo',
        responsaveis: 'Responsáveis',
        or: 'ou',
        grupo: 'Grupo',
        description: 'Descrição',
        description_placeholder: 'Introduza a descrição',
        disponivel: 'Disponível?',
        edit: 'Editar',
        event_poll: 'Sondagem',
        event_poll_ativar: 'Ativar Sondagem',
        event_poll_bloquear: 'Bloquear Sondagem',
        event_type: 'Tipo de Formulário',
        feriado: 'Feriado',
        field_activo: 'Ativo',
        field_preenchimento: 'Preenchimento',
        field_available: 'Disponível',
        field_category: 'Categoria',
        field_color: 'Cor',
        field_date: 'Data de início',
        field_description: 'Descrição',
        field_location: 'Localização',
        field_location_placeholder: 'Introduza a localização',
        field_title: 'Título do Formulário',
        field_name: 'Nome',
        field_poll_active: 'Ativar Sondagens',
        field_prioridade: 'Prioridade',
        field_select_colab: 'Seleção de Colaboradores',
        field_state: 'Estado',
        field_subtitle: 'Subtítulo',
        field_tag: 'Etiqueta',
        field_time: 'Hora de início',
        filtros: 'Filtros',
        filter_placeholder: 'Procurar',
        formacao: 'Formação',
        id: 'ID',
        insert_title: 'Novo Registo',
        location: 'Localização',
        meeting: 'Reunião',
        multipla: 'Múltipla',
        name: 'Nome',
        name_placeholder: 'Introduza o nome',
        nao_urgente: 'Não Urgente',
        no_items: 'Sem itens para mostrar',
        normal: 'Normal',
        other: 'Outro',
        pouco_urgente: 'Pouco Urgente',
        principal: 'Principal',
        remove: 'Remover',
        save: 'Salvar',
        select: 'Selecionar',
        select_placeholder: 'Seleccione o tipo de formulário',
        singular: 'Singular',
        tasks: 'Tarefas',
        tasks_on: 'Tarefas em',
        tarefas_agendadas: 'Tarefas Agendadas',
        tarefas_concluidas: 'Tarefas Concluídas',
        tarefas_criadas: 'Tarefas Criadas',
        tarefas_expiradas: 'Tarefas Expiradas',
        table_actions: 'Acções',
        table_all: 'Todos',
        table_date: 'Data',
        table_empty: 'Sem Resultados',
        table_parent: 'Parent',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_title: 'Título',
        tickets: 'Tickets',
        time: 'Hora de início',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        update: 'Atualizar',
        urgente: 'Urgente',
        view: 'Ver',
        video_conferencia: 'Video Conferência',
        votacao: 'Votação',
        votacao_oculta: 'Votação Oculta',
        livre: 'Livre',
        oculta: 'Oculta',
        votes: 'votos',
        workshop: 'Workshop',
        imprimir_relatorio: 'Imprimir Relatório',
        erro: 'Erro',
        sucesso: 'Sucesso',
        opcao: 'Adicionar Opção',
        questao: 'Adicionar Questão',
        adicionar_opcao: 'Adicionar opção?',
        confirmar_opcao: 'Queres mesmo adicionar a opção',
        remover_opcao: 'Remover opção?',
        remover_opcao_placeholder: 'Queres mesmo remover a opção',
        removida: 'Removida!',
        removida_placeholder: 'Opção removida com sucesso!',
        escolha: 'A tua escolha foi registada.',
        adicionada: 'Adicionada!',
        adicionada_placeholder: 'Opção adicionada com sucesso!',
        confirmar_voto: 'Confirmar voto?',
        confirmar_voto_placeholder: 'Queres mesmo votar nesta opção?',
        remover_voto: 'Remover voto?',
        remover_voto_placeholder: 'Queres mesmo remover o teu voto desta opção?',
        votado: 'Votado!',
        delete: 'Eliminar',
        delete_cancel: 'Não',
        delete_confirm: 'Sim',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_title: 'Eliminar Registo',
        edit_cancel: 'Não',
        edit_confirm: 'Sim',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_title: 'Editar Registo',
        insert_cancel: 'Não',
        insert_confirm: 'Sim',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        insert_text: 'Tem a certeza que pretende continuar?',
    },

    'en': {
        add: 'Add',
        add_new: 'Add Form',
        add_field: 'Add Field',
        all: 'All',
        back: 'Back',
        calendar: 'Calendar',
        calendar_allday: 'All day',
        calendar_busy: 'Busy',
        calendar_day: 'Day',
        calendar_daynames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        calendar_delete: 'Delete',
        calendar_edit: 'Edit',
        calendar_end_placeholder: 'End date',
        calendar_free: 'Free',
        calendar_language: 'en-US',
        calendar_location_placeholder: 'Location',
        calendar_month: 'Month',
        calendar_save: 'Save',
        calendar_start_placeholder: 'Start date',
        calendar_title_placeholder: 'Subject',
        calendar_today: 'Today',
        calendar_update: 'Update',
        calendar_viewall: 'View all',
        calendar_week: 'Week',
        calendar_year: 'Year',
        cancel: 'Cancel',
        category: 'Category',
        category_edit: 'Edit category',
        category_list: 'Category list',
        category_new: 'New category',
        close: 'Close',
        color: 'Color',
        color_placeholder: 'Enter the color',
        color_primary: 'Primary Color',
        color_secondary: 'Secondary Color',
        componente: 'Form',
        component_edit: 'Edit Form',
        component_list: 'Form List',
        component_new: 'New Form',
        conferencia: 'Conference',
        critica: 'Critical',
        date: 'Start date',
        delete: 'Delete',
        description: 'Description',
        description_placeholder: 'Enter the description',
        disponivel: 'Available?',
        edit: 'Edit',
        event_poll: 'Poll',
        event_poll_ativar: 'Activate Poll',
        event_poll_bloquear: 'Lock Poll',
        event_type: 'Form Type',
        feriado: 'Holiday',
        field_activo: 'Active',
        field_preenchimento: 'Filling',
        field_available: 'Available',
        field_category: 'Category',
        field_color: 'Color',
        field_date: 'Start date',
        field_description: 'Description',
        field_location: 'Location',
        field_location_placeholder: 'Enter the location',
        field_title: 'Title of the Form',
        field_name: 'Name',
        field_poll_active: 'Enable Polls',
        field_prioridade: 'Priority',
        field_select_colab: 'Collaborators Selection',
        field_state: 'State',
        field_subtitle: 'Subtitle',
        field_tag: 'Tag',
        field_time: 'Start time',
        filtros: 'Filters',
        filter_placeholder: 'Search',
        formacao: 'Training',
        id: 'ID',
        location: 'Location',
        meeting: 'Meeting',
        multipla: 'Multiple',
        name: 'Name',
        name_placeholder: 'Enter the name',
        nao_urgente: 'Not Urgent',
        no_items: 'No items to display',
        normal: 'Normal',
        other: 'Other',
        pouco_urgente: 'Low Urgency',
        principal: 'Main',
        remove: 'Remove',
        save: 'Save',
        select: 'Select',
        select_placeholder: 'Select the form type',
        singular: 'Single',
        tasks: 'Tasks',
        tasks_on: 'Tasks on',
        tarefas_agendadas: 'Scheduled Tasks',
        tarefas_concluidas: 'Completed Tasks',
        tarefas_criadas: 'Created Tasks',
        tarefas_expiradas: 'Expired Tasks',
        table_actions: 'Actions',
        table_all: 'All',
        table_date: 'Date',
        table_empty: 'No Results',
        table_parent: 'Parent',
        table_rows_per_page: 'Rows per page:',
        table_separator: 'of',
        table_state: 'State',
        table_title: 'Title',
        tickets: 'Tickets',
        time: 'Start time',
        title: 'Title',
        title_placeholder: 'Enter the title',
        update: 'Update',
        urgente: 'Urgent',
        view: 'View',
        video_conferencia: 'Video Conference',
        votacao: 'Voting',
        votacao_oculta: 'Hidden Voting',
        livre: 'Open',
        oculta: 'Hidden',
        votes: 'votes',
        workshop: 'Workshop',
        imprimir_relatorio: 'Print Report',
        erro: 'Error',
        sucesso: 'Success',
        opcao: 'Add Option',
        questao: 'Add Question',
        adicionar_opcao: 'Add option?',
        confirmar_opcao: 'Do you really want to add the option',
        remover_opcao: 'Remove option?',
        remover_opcao_placeholder: 'Do you really want to remove the option',
        removida: 'Removed!',
        removida_placeholder: 'Option removed successfully!',
        escolha: 'Your choice has been recorded.',
        adicionada: 'Added!',
        adicionada_placeholder: 'Option added successfully!',
        confirmar_voto: 'Confirm vote?',
        confirmar_voto_placeholder: 'Do you really want to vote for this option?',
        remover_voto: 'Remove vote?',
        remover_voto_placeholder: 'Do you really want to remove your vote from this option?',
        votado: 'Voted!',
        delete: 'Delete',
        delete_cancel: 'No',
        delete_confirm: 'Yes',
        delete_error: 'Error deleting record!',
        delete_success: 'Record deleted successfully!',
        delete_text: 'Are you sure you want to continue?',
        delete_title: 'Delete Record',
        edit_cancel: 'No',
        edit_confirm: 'Yes',
        edit_error: 'Error updating record!',
        edit_success: 'Record updated successfully!',
        edit_text: 'Are you sure you want to continue?',
        edit_title: 'Edit Record',
        insert_cancel: 'No',
        insert_confirm: 'Yes',
        insert_error: 'Error inserting record!',
        insert_success: 'Record inserted successfully!',
        insert_text: 'Are you sure you want to continue?',
    },

}

module.exports = {
    language
};